module.exports = __webpack_public_path__ + "img/wggg(1).c37fbb28.jpg";